import React, { Fragment } from "react";

import { IonToast, IonAlert } from "@ionic/react";

import { createUseStyles } from "react-jss";

import { ButtonLoading } from "../../components/Ui/ButtonLoading";

import { useButtonsState } from "../../hooks/useTicket";

const useStyles = createUseStyles({
  buttonStatus: {
    width: "100%"
  }
});

export const ButtonsStatus: React.FC<{id?: string | number; status?: string | number}>  = ({ id, status }) => {
  const classes = useStyles();
  const {
    handleAlertConfirm,
    showAlertConfirm,
    handleAlertCancel,
    showAlertCancel,
    loading,
    send,
    confirm,
    cancel,
    success,
    closeSuccess
  } = useButtonsState(id);

  return (
    <Fragment>
      <IonToast
        isOpen={success && (confirm || cancel)}
        onDidDismiss={() => closeSuccess()}
        message={confirm ? "Passagem confirmada com sucesso!" : "Passagem cancelada com sucesso!"}
        duration={3000}
        buttons={[
          {
            text: 'OK',
            role: 'cancel',
            handler: () => {
              closeSuccess();
            }
          }
        ]}
      />
      <IonAlert
        isOpen={showAlertConfirm}
        onDidDismiss={() => handleAlertConfirm(false)}
        header={'Confirmar passagem'}
        message={'Apos a confirmaçao da passagem, por favor nao <strong>cancele</strong>'}
        buttons={[
          {
            text: 'Nao',
            role: 'cancel',
            cssClass: 'secondary'
          },
          {
            text: 'Sim',
            handler: () => send()
          }
        ]}
      />
      <IonAlert
        isOpen={showAlertCancel}
        onDidDismiss={() => handleAlertConfirm(false)}
        header={'Deseja cancelar?'}
        message={'<strong>Cuidado</strong> com o cancelamento seu cliente espera a passagem!'}
        buttons={[
          {
            text: 'Nao',
            role: 'cancel',
            cssClass: 'secondary'
          },
          {
            text: 'Sim',
            handler: () => send("cancel")
          }
        ]}
      />
      <ButtonLoading
        loading={loading && confirm}
        disabled={status === 3}
        onClick={() => handleAlertConfirm(true)}
        style={{marginBottom: "0.5rem"}}
        className={classes.buttonStatus}
        text="Confirmar"
        textLoading="Confirmando..."
      />
      <ButtonLoading
        loading={loading && cancel}
        disabled={ status === 2}
        onClick={() => handleAlertCancel(true)}
        color="danger"
        className={classes.buttonStatus}
        text="Cancelar"
        textLoading="Cancelando..."
      />
    </Fragment>
  );
};